import { normalizeColor } from './normalizeColor'
import type { NormalizedColor, NormalizeColorOptions } from './types'

const MAX = 4096
const cache = new Map<string, NormalizedColor>()

function cacheKey(raw: string, options?: NormalizeColorOptions): string {
  const r = String(raw ?? '').trim().toLowerCase()
  const t = String(options?.trustedHex ?? '').trim().toLowerCase()
  return `${r}\0${t}`
}

/**
 * Memoized `normalizeColor` (per session). Safe for hot paths (grids, quick view).
 */
export function normalizeColorCached(raw: string, options?: NormalizeColorOptions): NormalizedColor {
  const trimmed = String(raw ?? '').trim()
  if (!trimmed && !String(options?.trustedHex ?? '').trim()) {
    return normalizeColor('', options)
  }
  const key = cacheKey(trimmed, options)
  const hit = cache.get(key)
  if (hit) return hit
  const next = normalizeColor(trimmed, options)
  if (cache.size >= MAX) {
    const firstKey = cache.keys().next().value
    if (firstKey) cache.delete(firstKey)
  }
  cache.set(key, next)
  return next
}

export function clearNormalizeColorCache(): void {
  cache.clear()
}
